<script>
    import {sgettext} from '../../i18n.js';
    export let workOrder;
    import {
        dashboardWorkOrder
    } from './dashBoardStrore.js';

    function setWorkOrder() {
        dashboardWorkOrder.set(workOrder)
    }

    $: if(workOrder === '' || workOrder === 'undefined') {
        dashboardWorkOrder.set('')
    }
</script>

<div class="wo-title">
    {sgettext("$$WORK_ORDER$$")}
</div>

<div class="wo-search">
    <form class="search-form" on:submit|preventDefault={setWorkOrder}>
      <input bind:value={workOrder} class="search-input" type="search"/>
    </form>
  </div>

<style>
    .wo-title {
        padding-right: 10px;
        padding-top: 8px;
	}

    .wo-search {
        width: auto;
        padding-right: 20px;
    }

    .search-input {
      height: 38px;
      width: 100%;
      max-width: 800px;
      border-radius: 4px;
      border: 1px solid #ccc;
      margin-bottom:10px;
    }
  
</style>
